import { render, staticRenderFns } from "./BasePhoneTable.vue?vue&type=template&id=78da3f4a"
import script from "./BasePhoneTable.vue?vue&type=script&lang=js"
export * from "./BasePhoneTable.vue?vue&type=script&lang=js"
import style0 from "./BasePhoneTable.vue?vue&type=style&index=0&id=78da3f4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports